import {createSelector} from "@reduxjs/toolkit";
import rootSelector from "../rootSelector";

export const themeConfigSelector = createSelector(rootSelector, state => state.themeConfig);
export const themeConfigShowLangsAsTextSelector = createSelector(themeConfigSelector, config => config.showLangsAsText);
export const themeConfigShowStatViewerFooter = createSelector(
  themeConfigSelector,
  config => config.showStatViewerFooter
);
export const themeConfigShowStatViewerInfoButton = createSelector(
  themeConfigSelector,
  config => config.showStatViewerInfoButton
);
export const themeConfigShowPackageListInCategoriesTree = createSelector(
  themeConfigSelector,
  config => config.showDatasetListInCategoriesTree
);
